import styled from "styled-components";
import { BLACK, NEUTRAL_100 } from "@styles/colors";
import { INTER } from "@styles/fonts";
import { safeAreaInset } from "@lib/telegram";

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 24px 12px 24px 12px;
  padding-bottom: ${safeAreaInset().bottom || 24}px;
  overflow-y: auto;
  height: 100%;
`;

export const ContentContainer = styled.div`
  gap: 24px;
  display: flex;
  flex-direction: column;
`;

export const TransferInfoContainer = styled.div`
  gap: 8px;
  display: flex;
  flex-direction: column;
`;

export const DestinationContainer = styled.div`
  padding: 16px 12px;
  border: 1px solid ${NEUTRAL_100};
  border-radius: 12px;
  gap: 8px;
  display: flex;
  flex-direction: column;
`;

export const DestinationLabel = styled.span`
  font-family: ${INTER.semiBold};
  color: ${BLACK};
`;
